import React from 'react'
import SbEditable from 'storyblok-react'

import Slider from 'react-slick'
import Image from '../atoms/Image'
import Richtext from '../atoms/Richtext'
import Headline from '../atoms/Headline'

const TimelineSliderBlock = ({ block }) => {
  function NextArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-right"></i>
      </span>
    )
  }

  function PrevArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-left"></i>
      </span>
    )
  }
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    mobileFirst: true,
    infinite: false,
    prevArrow: <PrevArrow className="slick-prev" />,
    nextArrow: <NextArrow className="slick-next" />,
    appendDots: (dots) => <ul> {dots} </ul>,
    customPaging: (i) => (
      <button>
        <span className="timeline-slider-block-slider-dot-text">
          {block?.timeline_items[i]?.indicator_text}
        </span>
        <span className="timeline-slider-block-slider-dot"></span>
      </button>
    ),
  }

  return (
    <SbEditable content={block}>
      <section className="timeline-slider-block">
        <div className="timeline-slider-block-container">
          <div className="timeline-slider-block-header">
            <Headline kicker={block.kicker} headline={block.headline} />
          </div>
          <Slider {...settings} className="timeline-slider-block-slider">
            {block.timeline_items?.length > 0 &&
              block.timeline_items.map((item, index) => (
                <div key={index} className="timeline-slider-block-slider-item">
                  <div className="timeline-slider-block-slider-item-row">
                    <div className="timeline-slider-block-slider-item-image">
                      <div className="timeline-slider-block-slider-item-image-container">
                        {item.component === 'timeline_slider_collage_item' ? (
                          <>
                            <div className="space-collage">
                              <div
                                className={`space-collage-tl ${
                                  item?.space_1_transparent
                                    ? 'bg-transparent'
                                    : ''
                                }`}
                              >
                                {item?.image_1?.filename?.length > 0 ? (
                                  <Image
                                    image={item?.image_1}
                                    imageHeight={500}
                                    imageWidth={500}
                                  />
                                ) : (
                                  <div></div>
                                )}
                              </div>
                              <div
                                className={`space-collage-tr ${
                                  item?.space_2_transparent
                                    ? 'bg-transparent'
                                    : ''
                                }`}
                              >
                                <div className="space-mask-tr">
                                  {item?.image_2?.filename?.length > 0 && (
                                    <Image
                                      image={item?.image_2}
                                      imageHeight={500}
                                      imageWidth={500}
                                    />
                                  )}
                                </div>
                              </div>
                              <div
                                className={`space-collage-bl ${
                                  item?.space_3_transparent
                                    ? 'bg-transparent'
                                    : ''
                                }`}
                              >
                                <div className="space-mask-bl">
                                  {item?.image_3?.filename?.length > 0 && (
                                    <Image
                                      image={item?.image_3}
                                      imageHeight={500}
                                      imageWidth={500}
                                    />
                                  )}
                                </div>
                              </div>
                              <div
                                className={`space-collage-br ${
                                  item?.space_4_transparent
                                    ? 'bg-transparent'
                                    : ''
                                }`}
                              >
                                {item?.image_4?.filename?.length > 0 ? (
                                  <Image
                                    image={item?.image_4}
                                    imageHeight={500}
                                    imageWidth={500}
                                  />
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="space-mask-single">
                            {item?.image?.filename?.length > 0 ? (
                              <Image
                                image={item?.image}
                                imageHeight={800}
                                imageWidth={800}
                              />
                            ) : (
                              <div></div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="timeline-slider-block-slider-item-content">
                      <div className="timeline-slider-block-slider-item-content-container">
                        {item?.year?.length > 0 && (
                          <span className="timeline-slider-block-slider-item-year">
                            {item?.year}
                          </span>
                        )}
                        {item?.title?.length > 0 && (
                          <span className="timeline-slider-block-slider-item-title">
                            {item?.title}
                          </span>
                        )}
                        {item?.text?.length > 0 && (
                          <Richtext
                            text={item?.text}
                            className="timeline-slider-block-slider-item-text"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </Slider>
        </div>
      </section>
    </SbEditable>
  )
}

export default TimelineSliderBlock
